// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\FeedbackResponse

export type FeedbackApiResponse = {
	message: string;
};

export type Feedback = {
	message: string;
};

export function hydrateFeedback(data: FeedbackApiResponse): Feedback {
	return { ...data };
}